import deepEqual from 'deep-equal';

const equalOpts = { strict: true }; // no coercive euqality.

export const deepEquals = (a: any, b: any) => deepEqual(a, b, equalOpts);
